// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";

function testAny(x) {
  return x === undefined;
}

function getExn(f) {
  if (f !== undefined) {
    return f;
  }
  throw new Caml_js_exceptions.MelangeError(new Error("Js.Undefined.getExn").MEL_EXN_ID, new Error("Js.Undefined.getExn"));
}

function map(f, x) {
  if (x !== undefined) {
    return f(x);
  }
  
}

function bind(f, x) {
  if (x !== undefined) {
    return f(x);
  }
  
}

function iter(f, x) {
  if (x !== undefined) {
    return f(x);
  }
  
}

function fromOption(x) {
  if (x !== undefined) {
    return Caml_option.valFromOption(x);
  }
  
}

export {
  testAny,
  getExn,
  map,
  bind,
  iter,
  fromOption,
}
/* No side effect */
